<i18n>
    [
        "product__shoppableImage--cta",
    ]
</i18n>

<template>
    <div>
        <AppIcon
            :isCoreDir="true"
            icon="global--eye"
            size="16px"
            color="gray"
            class="c-catalog-shop-the-look"
        />
        {{ $t('product__shoppableImage--cta') }}
    </div>
</template>

<script>
export default {
    name: 'CatalogShopTheLook',
};
</script>

<style lang='scss'>
    .c-catalog-shop-the-look {
        margin-right: $nu-spacer-1;
    }
</style>
